<template>
  <section
    class="app-section app-section-light-grey container-fluid g-0 pb-0 pt-0 mb-0"
  >
    <PageLayout :screenWidth="windowWidth" :loaded="meta.loaded">
      <h1
        v-if="$route.params.wishlistType === 'honeymoon'"
        class="section-heading pt-5"
      >
        Welcome to Trailfinders Honeymoon Wishlist
      </h1>
      <h1
        v-if="$route.params.wishlistType === 'giftlist'"
        class="section-heading pt-5"
      >
        Welcome to Trailfinders Celebration Wishlist
      </h1>

      <div role="tabpanel" class="tab-panel active" id="setup">
        <section
          class="row"
          style="margin-right: 0px;margin-left: 0px;"
        >
          <div>
            <section
              class="row container-fluid justify-content-center"
              id="edit-column-width"
            >
              <b-col :sm="10">
                <p
                  v-if="$route.params.wishlistType === 'honeymoon'"
                  class="text-center"
                >
                  Congratulations on behalf of everyone at Trailfinders.
                </p>

                <p
                  v-if="$route.params.wishlistType === 'honeymoon'"
                  class="text-center"
                >
                  We appreciate you’ve got enough to do preparing for your big
                  day, so take comfort in knowing there is an easy way for your
                  friends and family to help make your honeymoon truly special.
                </p>

                <p
                  v-if="$route.params.wishlistType === 'honeymoon'"
                  class="text-center"
                >
                  Our free of charge Honeymoon Wishlist can be set up at any
                  time, even before you've made your travel plans. You’ll have
                  your own personalised website where your friends and family
                  can share in your excitement, keep up to date with your
                  wedding and honeymoon plans, make a contribution to your dream
                  honeymoon and post their congratulations.
                </p>

                <p
                  v-if="$route.params.wishlistType === 'honeymoon'"
                  class="text-center"
                >
                  We'll provide you with personalised guest cards (electronic
                  and/or printed) for your invitations which will let everyone
                  know your preference for the gift of travel. Each time your
                  guests contribute to your Wishlist we’ll send you an alert and
                  an automated thank you on your behalf.
                </p>

                <p
                  v-if="$route.params.wishlistType === 'honeymoon'"
                  class="text-center"
                >
                  Our honeymoon experts offer a wealth of extensive travel
                  knowledge, award-winning service and are on hand to look after
                  you every step of the way. Combine this with our Honeymoon
                  Wishlist service, and Trailfinders can create your trip of a
                  lifetime.
                </p>

                <p
                  v-if="$route.params.wishlistType === 'honeymoon'"
                  class="text-center"
                >
                  To sign up to the Trailfinders Honeymoon Wishlist simply enter
                  your details below.
                </p>

                <p
                  v-if="$route.params.wishlistType === 'giftlist'"
                  class="text-center"
                >
                  Whether celebrating an anniversary, birthday or retirement, a
                  Trailfinders Wishlist is an easy way to give friends, family
                  and colleagues the chance to contribute towards a holiday of a
                  lifetime.
                </p>

                <p
                  v-if="$route.params.wishlistType === 'giftlist'"
                  class="text-center"
                >
                  If planning a wedding or honeymoon, please visit our
                  <a href="/">Honeymoon Wishlist</a> page.
                </p>

                <p
                  v-if="$route.params.wishlistType === 'giftlist'"
                  class="text-center"
                >
                  Our free of charge Wishlist can be set up by anyone, for
                  anyone, at any time. You’ll create a personalised website
                  where friends, family or colleagues can share in the
                  excitement, keep up to date with holiday plans, make a
                  contribution and post messages.
                </p>

                <p
                  v-if="$route.params.wishlistType === 'giftlist'"
                  class="text-center"
                >
                  We'll provide personalised cards (electronic and/or printed)
                  which can be shared with all those wishing to contribute.
                  Every contribution prompts an alert to the organiser and an
                  automated thank you to the contributor.
                </p>

                <p
                  v-if="$route.params.wishlistType === 'giftlist'"
                  class="text-center"
                >
                  To sign up to the Trailfinders Celebration Wishlist simply
                  enter your details below.
                </p>
                <br/>
                <!-- form -->
                <b-form id="apptForm" @submit="onSubmit">
                  <div class="form-group">
                    <hr class="hr-02" />
                    <h3
                      v-if="$route.params.wishlistType === 'honeymoon'"
                      class="pb-5 pt-3"
                      style="text-align:center;"
                    >
                      Set up your Honeymoon Wishlist today
                    </h3>

                    <h3
                      v-if="$route.params.wishlistType === 'giftlist'"
                      class="pb-5"
                      style="text-align:center;"
                    >
                      Set up your Celebration Wishlist today
                    </h3>

                    <!-- Wishlist is for? -->
                    <b-row
                      v-if="$route.params.wishlistType === 'giftlist'"
                      class="pt-3"
                    >
                      <div class="col-12">
                        <div class="form-group">
                          <section class="row">
                            <div class="col-4">
                              <label style="margin-top: 3%;"
                                >Who is this Wishlist for?<span class="required"
                                  >*</span
                                ></label
                              >
                            </div>
                            <div class="col-8">
                              <b-row>
                                <b-col sm="5">
                                  <b-form-radio
                                    v-model.trim="isForMe"
                                    name="isForMe"
                                    value="true"
                                    type="radio"
                                    :state="validateState('isForMe')"
                                    @change="touchField($v.isForMe)"
                                    >&nbsp;This Wishlist is for me</b-form-radio
                                  >
                                </b-col>

                                <b-col sm="7">
                                  <b-form-radio
                                    v-model.trim="isForMe"
                                    name="isForMe2"
                                    value="false"
                                    class="float-start"
                                    :state="validateState('isForMe')"
                                    @change="touchField($v.isForMe)"
                                    >&nbsp;This Wishlist is for someone
                                    else</b-form-radio
                                  >
                                </b-col>
                              </b-row>
                            </div>
                          </section>
                        </div>
                      </div>
                    </b-row>

                    <!-- Wishlist Type -->
                    <b-row
                      class="pb-3"
                      v-if="$route.params.wishlistType === 'giftlist'"
                    >
                      <div class="col-4">
                        <label for="FirstName"
                          >Wishlist Type<span class="required">*</span></label
                        >
                      </div>
                      <div class="col-8">
                        <div class="select-holder">
                          <b-form-select
                            class="form-select"
                            v-model.trim="wishlistType"
                            id="type-input-1"
                            name="type-input-1"
                            :options="wishlistOptions"
                            :state="validateState('wishlistType')"
                            @change="touchField($v.wishlistType)"
                          >
                          </b-form-select>
                        </div>
                      </div>
                    </b-row>

                    <!-- Organiser First Name -->
                    <b-row
                      v-if="
                        isForMe === 'false' &&
                          $route.params.wishlistType === 'giftlist'
                      "
                      class="pb-3"
                    >
                      <!--  First Name -->
                      <div class="col-sm-4">
                        <label for="FirstNameOrg"
                          >Organiser First Name<span class="required"
                            >*</span
                          ></label
                        >
                      </div>
                      <div class="col-sm-2 pt-2">
                        <div class="select-holder">
                          <b-form-select
                            class="form-select"
                            v-model.trim="titleOrg"
                            id="titleOrg"
                            name="titleOrg"
                            :options="titleOptions"
                            :state="validateState('titleOrg')"
                            @change="touchField($v.titleOrg)"
                          >
                          </b-form-select>
                          <div
                            class="alert alert-danger m-b-0"
                            v-if="$v.titleOrg.$dirty && !$v.titleOrg.required"
                          >
                            Please select a title.
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4 pt-2">
                        <b-form-input
                          v-model.trim="firstnameOrg"
                          id="example-input-1"
                          style=" border-radius:5px"
                          placeholder="Firstname"
                          :state="validateState('firstnameOrg')"
                          @change="touchField($v.firstnameOrg)"
                        >
                        </b-form-input>
                        <div
                          class="alert alert-danger m-b-0"
                          v-if="
                            $v.firstnameOrg.$dirty && !$v.firstnameOrg.required
                          "
                        >
                          Field is required
                        </div>
                      </div>
                      <!-- </div> -->
                    </b-row>

                    <!-- Organiser Last Name -->
                    <b-row
                      v-if="
                        isForMe === 'false' &&
                          $route.params.wishlistType === 'giftlist'
                      "
                      class="pb-3"
                    >
                      <div class="col-sm-4">
                        <label for="LastName"
                          >Organiser Last Name<span class="required"
                            >*</span
                          ></label
                        >
                      </div>
                      <div class="col-sm-6">
                        <b-form-input
                          v-model.trim="lastnameOrg"
                          id="example-input-1"
                          style=" border-radius:5px"
                          placeholder="Lastname"
                          :state="validateState('lastnameOrg')"
                          @change="touchField($v.lastnameOrg)"
                        >
                        </b-form-input>
                        <div
                          class="alert alert-danger m-b-0"
                          v-if="
                            $v.lastnameOrg.$dirty && !$v.lastnameOrg.required
                          "
                        >
                          Field is required
                        </div>
                      </div>
                    </b-row>

                    <!-- Person 1 First Name -->
                    <b-row class="pb-3">
                      <div class="col-4">
                        <label
                          v-if="
                            isForMe === 'false' &&
                              $route.params.wishlistType === 'giftlist'
                          "
                          for="FirstName1"
                          >Recipient First Name<span class="required"
                            >*</span
                          ></label
                        >
                        <label v-else for="FirstName2"
                          >Your First Name<span class="required">*</span></label
                        >
                      </div>
                      <div class="col-2 pt-2">
                        <div class="select-holder">
                          <b-form-select
                            class="form-select"
                            v-model.trim="title"
                            id="title-input-1"
                            name="title-input-1"
                            :options="titleOptions"
                            :state="validateState('title')"
                            @change="touchField($v.title)"
                          >
                          </b-form-select>
                          <div
                            class="alert alert-danger mb-0"
                            v-if="$v.title.$dirty && !$v.title.required"
                          >
                            Please select a title.
                          </div>
                        </div>
                      </div>
                      <div class="col-6 pt-2">
                        <b-form-input
                          v-model.trim="firstname"
                          id="example-input-1"
                          style=" border-radius:5px"
                          placeholder="Firstname"
                          :state="validateState('firstname')"
                          @change="touchField($v.firstname)"
                        >
                        </b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="$v.firstname.$dirty && !$v.firstname.required"
                        >
                          Field is required
                        </div>
                      </div>
                    </b-row>

                    <!-- Person 1 Last Name -->
                    <b-row class="pb-3">
                      <div class="col-4">
                        <label
                          v-if="
                            isForMe === 'false' &&
                              $route.params.wishlistType === 'giftlist'
                          "
                          for="LastName"
                          >Recipient Last Name<span class="required"
                            >*</span
                          ></label
                        >
                        <label v-else for="LastName"
                          >Your Last Name<span class="required">*</span></label
                        >
                      </div>
                      <div class="col-8">
                        <b-form-input
                          v-model.trim="lastname"
                          id="example-input-1"
                          style=" border-radius:5px"
                          placeholder="Lastname"
                          :state="validateState('lastname')"
                          @change="touchField($v.lastname)"
                        >
                        </b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="$v.lastname.$dirty && !$v.lastname.required"
                        >
                          Field is required
                        </div>
                      </div>

                      <div
                        v-if="
                          $route.params.wishlistType === 'giftlist' &&
                            numberOfFields === 0
                        "
                        class="col-2"
                      >
                        <p class=" mb-0" @click="onClicker('plus')">
                          <b-icon
                            class="h3 mb-0 border border-2 border-dark p-3 rounded"
                            style=""
                            icon="person-plus"
                          ></b-icon>
                          Add Person
                        </p>
                      </div>
                    </b-row>

                    <!-- Person 2 First Name -->
                    <b-row
                      v-if="$route.params.wishlistType === 'honeymoon'"
                      class="pb-3"
                    >
                      <div class="col-4">
                        <label for="FirstName2"
                          >Your Partners First Name<span class="required"
                            >*</span
                          ></label
                        >
                      </div>
                      <div class="col-2 pt-2">
                        <div class="select-holder">
                          <b-form-select
                            class="form-select"
                            v-model.trim="title2"
                            id="title-input-2"
                            name="title-input-2"
                            :options="titleOptions"
                          >
                          </b-form-select>
                          <div
                            class="alert alert-danger mb-0"
                            v-if="$v.title2.$dirty && !$v.title2.required"
                          >
                            Please select a title.
                          </div>
                        </div>
                      </div>

                      <div class="col-6 pt-2">
                        <b-form-input
                          v-model.trim="firstname2"
                          id="example-input-1"
                          style=" border-radius:5px"
                          placeholder="Firstname"
                        >
                        </b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="$v.firstname2.$dirty && !$v.firstname2.required"
                        >
                          Field is required
                        </div>
                      </div>
                    </b-row>

                    <!-- Person 2 Last Name -->
                    <b-row
                      v-if="$route.params.wishlistType === 'honeymoon'"
                      class="pb-3"
                    >
                      <div class="col-sm-4">
                        <label for="LastName2"
                          >Your Partners Last Name<span class="required"
                            >*</span
                          ></label
                        >
                      </div>
                      <div class="col-8">
                        <b-form-input
                          v-model.trim="lastname2"
                          id="example-input-1"
                          style=" border-radius:5px"
                          placeholder="Lastname"
                        >
                        </b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="$v.lastname2.$dirty && !$v.lastname2.required"
                        >
                          Field is required
                        </div>
                      </div>
                    </b-row>

                    <!-- Multile People -->
                    <template v-for="(itemFirstname, index) in numberOfFields">
                      <b-row
                        v-if="$route.params.wishlistType === 'giftlist'"
                        class="pb-3"
                        :key="itemFirstname"
                      >
                        <div class="col-4">
                          <label v-if="isForMe === 'false'" for="FirstNameMult"
                            >Recipient First Name {{ itemFirstname + 1
                            }}<span class="required">*</span></label
                          >
                          <label v-else for="FirstNameMult"
                            >First Name {{ itemFirstname + 1
                            }}<span class="required">*</span></label
                          >
                        </div>

                        <div class="col-2 pt-2">
                          <div class="select-holder">
                            <template>
                              <b-form-select
                                class="form-select"
                                v-model="$data['title_' + itemFirstname]"
                                id="FirstName"
                                name="FirstName"
                                :options="titleOptions"
                              >
                              </b-form-select>
                            </template>
                          </div>
                        </div>

                        <div class="col-6 pt-2">
                          <template>
                            <b-form-input
                              type="text"
                              v-model="$data['firstname_' + itemFirstname]"
                              id="example-input-1"
                              style=" border-radius:5px"
                              placeholder="Firstname"
                            >
                            </b-form-input>
                          </template>
                        </div>
                      </b-row>

                      <!-- Multiple People Last Name -->
                      <b-row
                        v-if="$route.params.wishlistType === 'giftlist'"
                        class="pb-3"
                        :key="index + 'a'"
                      >
                        <div class="col-4">
                          <label v-if="isForMe === 'false'" for="LastName"
                            >Recipient Last Name {{ index + 2
                            }}<span class="required">*</span></label
                          >
                          <label v-else for="LastName"
                            >Last Name {{ index + 2
                            }}<span class="required">*</span></label
                          >
                        </div>
                        <div class="col-6">
                          <template>
                            <b-form-input
                              type="text"
                              v-model="$data['lastname_' + (index + 1)]"
                              id="LastName"
                              style=" border-radius:5px"
                              placeholder="Lastname"
                            >
                            </b-form-input>
                          </template>
                        </div>
                        <div class="col-2 m-0 p-0 ps-3 pe-1">
                          <p
                            class="h2 m-0 p-0 float-start ps-0 pe-1"
                            @click="onClicker('plus')"
                          >
                            <b-icon
                              class="align-top my-1 border border-2 border-secondary rounded text-dark p-1"
                              icon="person-plus"
                              fill="#888"
                            ></b-icon>
                          </p>
                          <p
                            class="h2 m-0 p-0 float-start ps-0 pe-1"
                            @click="onClicker('minus')"
                          >
                            <b-icon
                              class="align-top my-1 border border-2 border-secondary rounded text-dark p-1"
                              icon="person-dash"
                            ></b-icon>
                          </p>
                        </div>
                      </b-row>
                    </template>

                    <!-- Email -->
                    <b-row class="pb-3">
                      <div class="col-4">
                        <label v-if="isForMe === 'false'" for="Email"
                          >Organiser Email Address<span class="required"
                            >*</span
                          ></label
                        >
                        <label v-else for="Email"
                          >Your Email Address<span class="required"
                            >*</span
                          ></label
                        >
                      </div>
                      <div class="col-8">
                        <b-form-input
                          type="email"
                          placeholder="Email Address"
                          v-model.trim="email"
                          :state="validateState('email')"
                          @change="touchField($v.email)"
                        ></b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="$v.email.$dirty && !$v.email.required"
                        >
                          Field is required
                        </div>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="!$v.email.email || !$v.email.minLength"
                        >
                          Must be a valid e-mail
                          <small
                            >e.g. example@example.com (Must contain
                            lowercase)</small
                          >
                        </div>
                      </div>
                    </b-row>

                    <!-- Contact Number -->
                    <b-row class="pb-3">
                      <div class="col-4">
                        <label v-if="isForMe === 'false'" for="ContactNumber"
                          >Organiser Contact Number
                          <span class="required">*</span></label
                        >
                        <label v-else for="ContactNumber"
                          >Your Contact Number
                          <span class="required">*</span></label
                        >
                      </div>
                      <div class="col-8">
                        <b-form-input
                          type="tel"
                          placeholder="Contact Telephone Number"
                          v-model.trim="telephone"
                          :state="validateState('telephone')"
                          @change="touchField($v.telephone)"
                        ></b-form-input>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="$v.telephone.$dirty && !$v.telephone.required"
                        >
                          Field is required
                        </div>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="!$v.telephone.numeric"
                        >
                          Must be a valid telephone number
                          <small
                            >e.g. 01234567891 (Must not contain spaces)</small
                          >
                        </div>
                        <!-- <div class="alert alert-danger m-b-0" v-if="!$v.telephone.numeric || !$v.telephone.minLength">Must be a valid number</div> -->
                      </div>
                    </b-row>

                    <!-- Address In UK -->
                    <b-row v-if="isUK">
                      <!-- <div class="col-xs-12">
                        <div class="form-group"> -->
                      <!-- <section class="row"> -->
                      <div class="col-4">
                        <label
                          >Is your address in the UK?<span class="required"
                            >*</span
                          ></label
                        >
                      </div>
                      <div class="col-4">
                        <b-row style="margin-left:15px; margin-right:15px;">
                          <b-col sm="6" class="ps-0">
                            <b-form-radio
                              v-model.trim="isAddressUk"
                              name="isAddressUk"
                              value="Yes"
                              :state="validateState('isAddressUk')"
                              @change="touchField($v.isAddressUk)"
                              >&nbsp;Yes</b-form-radio
                            >
                          </b-col>

                          <b-col sm="6" class="ps-0">
                            <b-form-radio
                              v-model.trim="isAddressUk"
                              name="isAddressUk2"
                              value="No"
                              :state="validateState('isAddressUk')"
                              @change="touchField($v.isAddressUk)"
                              >&nbsp;No</b-form-radio
                            >
                          </b-col>
                        </b-row>
                      </div>
                      <!-- </section> -->
                      <!-- </div>
                      </div> -->
                    </b-row>

                    <!-- Address In IE -->
                    <b-row v-if="isIe">
                      <!-- <div class="col-xs-12"> -->
                      <!-- <div class="form-group"> -->
                      <!-- <section class="row"> -->
                      <div class="col-4">
                        <label
                          >Is your address in Ireland?<span class="required"
                            >*</span
                          ></label
                        >
                      </div>
                      <div class="col-sm-4">
                        <b-row style="margin-left:15px; margin-right:15px;">
                          <b-col sm="6" class="ps-0">
                            <b-form-radio
                              v-model.trim="isAddressIe"
                              name="isAddressIe"
                              value="Yes"
                              :state="validateState('isAddressIe')"
                              @change="touchField($v.isAddressIe)"
                              >&nbsp;Yes</b-form-radio
                            >
                          </b-col>

                          <b-col sm="6" class="ps-0">
                            <b-form-radio
                              v-model.trim="isAddressIe"
                              name="isAddressIe2"
                              value="No"
                              :state="validateState('isAddressIe')"
                              @change="touchField($v.isAddressIe)"
                              >&nbsp;No</b-form-radio
                            >
                          </b-col>
                        </b-row>
                      </div>
                      <!-- </section> -->
                      <!-- </div>
                      </div> -->
                    </b-row>

                    <!-- Postcode Lookup -->
                    <b-row v-if="isAddressUk !== 'No' && isAddressIe !== 'No'">
                      <!-- <div class="form-group"> -->
                      <!-- <section
                          class="row"
                          style="margin-left: 0px; margin-right:0px;"
                        > -->
                      <b-col sm="4">
                        <label v-if="isForMe === 'false'" for="postcode"
                          >Organiser Postal Address<span class="required"
                            >*</span
                          ></label
                        >
                        <label v-else for="postcode"
                          >Postal Address<span class="required">*</span></label
                        >
                      </b-col>
                      <b-col sm="8">
                        <Autoaddress
                          v-if="isIe"
                          licencekey="2e9c9e91-eda5-472e-ae24-7d3569bec687"
                          vanityMode="true"
                          addressProfile="Demo5LineV2"
                          country="ie"
                          language="en"
                          noResultFoundLabel="No search results have been found.Please enter address manually below."
                          @onAddressFound="foundAddress($event)"
                        />
                        <div v-if="isUK">
                          <b-form-input
                            v-model.trim="postcodeSearch"
                            @input="postcodeLookup"
                            type="text"
                            id="post-code"
                            placeholder="Enter Postcode"
                          />

                          <div
                            class="post-code-results"
                            v-if="postcodeDropdown"
                          >
                            <ul>
                              <li
                                @click="handleSelection(address.suggestion)"
                                v-for="(address, index) in postcodeResult"
                                :key="index"
                              >
                                {{ address.suggestion }}
                              </li>
                            </ul>
                          </div>
                          <p class="">
                            or enter address manually below ...
                          </p>
                        </div>
                      </b-col>
                      <!-- </section>
                      </div> -->
                    </b-row>

                    <!-- Address Info -->
                    <b-row
                      v-if="
                        addressFound ||
                          isAddressUk === 'No' ||
                          isAddressIe === 'No'
                      "
                    >
                      <div class="col-12">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-4">
                              <label for="address1"
                                >Address 1
                                <span class="required">*</span></label
                              >
                            </div>
                            <div class="col-8">
                              <b-form-input
                                v-model.trim="addressLine1"
                                placeholder="Address Line 1"
                                :state="validateState('addressLine1')"
                                @change="touchField($v.addressLine1)"
                              ></b-form-input>
                              <div
                                class="alert alert-danger m-b-0"
                                v-if="
                                  $v.addressLine1.$dirty &&
                                    !$v.addressLine1.required
                                "
                              >
                                Field is required
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-4">
                              <label for="address2"
                                >Address 2
                                <span class="required">*</span></label
                              >
                            </div>
                            <div class="col-8">
                              <b-form-input
                                v-model.trim="addressLine2"
                                placeholder="Address Line 2"
                                :state="validateState('addressLine2')"
                                @change="touchField($v.addressLine2)"
                              ></b-form-input>
                              <div
                                class="alert alert-danger mb-0"
                                v-if="
                                  $v.addressLine2.$dirty &&
                                    !$v.addressLine2.required
                                "
                              >
                                Field is required
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-4">
                              <label for="address3"
                                >Address 3<span class="required">*</span></label
                              >
                            </div>
                            <div class="col-8">
                              <b-form-input
                                v-model.trim="addressLine3"
                                placeholder="Address Line 3"
                                :state="validateState('addressLine3')"
                                @change="touchField($v.addressLine3)"
                              ></b-form-input>
                              <div
                                class="alert alert-danger mb-0"
                                v-if="
                                  $v.addressLine3.$dirty &&
                                    !$v.addressLine3.required
                                "
                              >
                                Field is required
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group" v-if="isUK">
                          <div class="row">
                            <div class="col-4">
                              <label v-if="isAddressUk === 'No'" for="postcode"
                                >Postal Code / Zip Code<span class="required"
                                  >*</span
                                ></label
                              >
                              <label v-else for="postcode"
                                >Postcode<span class="required">*</span></label
                              >
                            </div>
                            <div class="col-8">
                              <b-form-input
                                v-if="isAddressUk === 'No'"
                                v-model.trim="postCode"
                                placeholder="Postal Code / Zip Code"
                                :state="validateState('postCode')"
                                @change="touchField($v.postCode)"
                              ></b-form-input>
                              <b-form-input
                                v-else
                                v-model.trim="postCode"
                                placeholder="Postcode"
                                :state="validateState('postCode')"
                                @change="touchField($v.postCode)"
                              ></b-form-input>
                              <div
                                class="alert alert-danger mb-0"
                                v-if="
                                  $v.postCode.$dirty && !$v.postCode.required
                                "
                              >
                                Field is required
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group" v-if="isIe">
                          <div class="row">
                            <div class="col-4">
                              <label v-if="isAddressIe === 'No'" for="postcode"
                                >Postal Code / Zip Code<span class="required"
                                  >*</span
                                ></label
                              >
                              <label v-else for="postcode"
                                >Eircode<span class="required">*</span></label
                              >
                            </div>
                            <div class="col-8">
                              <b-form-input
                                v-if="isAddressIe === 'No'"
                                v-model.trim="postCode"
                                placeholder="Postal Code / Zip Code"
                                :state="validateState('postCode')"
                                @change="touchField($v.postCode)"
                              ></b-form-input>
                              <b-form-input
                                v-else
                                placeholder="postcode"
                                v-model.trim="postCode"
                                :state="validateState('postCode')"
                                @change="touchField($v.postCode)"
                              ></b-form-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-row>

                    <!-- Select Wedding Date -->
                    <b-row>
                      <div class="col-4">
                        <label
                          v-if="
                            $route.params.wishlistType === 'honeymoon' &&
                              isForMe === 'false'
                          "
                          for="wedDay"
                          >Select Wedding Date
                          <span class="required">*</span></label
                        >
                        <label
                          v-if="
                            $route.params.wishlistType === 'giftlist' &&
                              isForMe === 'false'
                          "
                          for="wedDay"
                          >Select Celebration Date
                          <span class="required">*</span></label
                        >
                        <label
                          v-if="
                            $route.params.wishlistType === 'honeymoon' &&
                              isForMe !== 'false'
                          "
                          for="wedDay"
                          >Select Your Wedding Date
                          <span class="required">*</span></label
                        >
                        <label
                          v-if="
                            $route.params.wishlistType === 'giftlist' &&
                              isForMe !== 'false'
                          "
                          for="wedDay"
                          >Select Your Celebration Date
                          <span class="required">*</span></label
                        >
                      </div>
                      <div class="col-8">
                        <div class="less-margin">
                          <section class="row less-padding g-0">
                            <b-col sm="6">
                              <b-form-datepicker
                                v-model.trim="weddingDate"
                                :min="min"
                                reset-button
                                reset-value=""
                                locale="en"
                                close-button
                                start-weekday="1"
                                :date-format-options="{
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric',
                                }"
                                class="dp-nudge"
                                aria-describedby="input-13-live-feedback"
                                :state="validateState('weddingDate')"
                                @change="touchField($v.weddingDate)"
                              ></b-form-datepicker>
                              <div
                                class="alert alert-danger mb-0"
                                v-if="
                                  $v.weddingDate.$dirty &&
                                    !$v.weddingDate.required
                                "
                              >
                                Field is required
                              </div>
                            </b-col>
                          </section>
                        </div>
                      </div>
                    </b-row>

                    <!-- Select Closing Date -->
                    <b-row v-if="weddingDate !== ''">
                      <div class="col-4">
                        <label
                          >Closing Date <span class="required">*</span></label
                        >
                      </div>
                      <div class="col-8">
                        <div class="less-margin">
                          <section class="row less-padding">
                            <b-col sm="6">
                              <b-form-datepicker
                                v-model.trim="cutOffDate"
                                reset-button
                                reset-value=""
                                start-weekday="1"
                                locale="en"
                                :min="minCutOff"
                                :max="maxCutOff"
                                close-button
                                class="dp-nudge"
                                aria-describedby="input-13-live-feedback"
                                :date-format-options="{
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric',
                                }"
                                :state="validateState('cutOffDate')"
                                @change="touchField($v.cutOffDate)"
                              ></b-form-datepicker>
                              <div
                                class="alert alert-danger mb-0"
                                v-if="
                                  $v.cutOffDate.$dirty &&
                                    !$v.cutOffDate.required
                                "
                              >
                                Field is required
                              </div>
                            </b-col>
                          </section>
                        </div>
                      </div>
                    </b-row>

                    <!-- Closing Option Radios -->
                    <b-row>
                      <div class="col-4">
                        <label>Closing Options</label>
                      </div>

                      <div class="col-8" id="register-well">
                        <div role="alert">
                          <p
                            v-if="$route.params.wishlistType === 'giftlist'"
                            role="alert"
                          >
                            <small>
                              To have contributions transferred to a
                              Trailfinders holiday once the Closing Date has
                              passed, select ‘Add to my booking’ below. If final
                              payment for the booking is made before the
                              Wishlist Closing Date, contributions will be
                              credited to the booking and we will refund the
                              original form of payment. Should there be any
                              excess funds, these will be e-mailed to you as a
                              Trailfinders Electronic Gift Card which is valid
                              indefinitely.
                              <br /><br />
                              Alternatively, select ‘Email me a Gift Card’ to
                              receive the total contributions as a Trailfinders
                              Electronic Gift Card to be used towards future
                              travel.
                            </small>
                          </p>
                          <p v-if="$route.params.wishlistType === 'honeymoon'">
                            <small
                              >To have contributions transferred to your
                              Trailfinders Honeymoon once the Closing Date has
                              passed, select ‘Add to my booking’ below. If your
                              final payment for the booking is made before the
                              Wishlist Closing Date, contributions will be
                              credited to the booking and we will refund the
                              original form of payment. Should there be any
                              excess funds, these will be e-mailed to you as a
                              Trailfinders Electronic Gift Card which is valid
                              indefinitely. <br /><br />
                              Alternatively, select ‘Email me a Gift Card’ to
                              receive your total contributions as a Trailfinders
                              Electronic Gift Card to be used towards future
                              travel.
                            </small>
                          </p>

                          <b-row class="ms-0">
                            <b-col class="px-0" sm="12">
                              <b-form-radio
                                size="sm"
                                v-model.trim="closingOption"
                                name="closingOption"
                                value="BOOKING"
                                class="float-start"
                                :state="validateState('closingOption')"
                                @change="touchField($v.closingOption)"
                                >&nbsp;Add to my booking</b-form-radio
                              >
                            </b-col>
                          </b-row>

                          <b-row
                            class="ms-1 mt-2"
                            v-if="closingOption === 'BOOKING'"
                          >
                            <div class="col-8">
                              <b-row>
                                <div class="col-9 pb-2">
                                  <b-form-input
                                    v-model.trim="bookingRef"
                                    placeholder="Booking Reference"
                                    :state="validateState('bookingRef')"
                                    @change="touchField($v.bookingRef)"
                                  ></b-form-input>
                                  <b-form-checkbox
                                    size="sm"
                                    id="noBookRef"
                                    class="mt-2"
                                    v-model="recipient.noBookRef"
                                    name="noBookRef"
                                    value="true"
                                    unchecked-value="false"
                                    :state="validateState('noBookRef')"
                                    @change="touchField($v.noBookRef)"
                                    >&nbsp;I don’t know my
                                    reference</b-form-checkbox
                                  >
                                </div>
                              </b-row>
                            </div>
                          </b-row>

                          <b-row class="ms-0">
                            <b-col class="px-0" sm="12">
                              <b-form-radio
                                size="sm"
                                v-model.trim="closingOption"
                                name="closingOption"
                                value="GIFTCARD"
                                class="pull-left"
                                :state="validateState('closingOption')"
                                @change="touchField($v.closingOption)"
                                >&nbsp;Email me a Gift Card</b-form-radio
                              >
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                    </b-row>

                    <b-row
                      v-if="
                        closingOption === 'GIFTCARD' &&
                          $route.params.wishlistType === 'giftlist' &&
                          isForMe === 'false'
                      "
                      class="pb-3"
                    >
                      <div class="col-4"></div>
                      <div class="col-6">
                        <h4 class="section-heading mb-1 pt-0">
                          Gift Card Details
                        </h4>
                      </div>
                    </b-row>

                    <!-- Gift Recipient First Name -->
                    <b-row
                      v-if="
                        closingOption === 'GIFTCARD' &&
                          $route.params.wishlistType === 'giftlist' &&
                          isForMe === 'false'
                      "
                      class="pb-3"
                    >
                      <div class="col-sm-4">
                        <label for="FirstName"
                          >Recipient First Name<span class="required"
                            >*</span
                          ></label
                        >
                      </div>
                      <div class="col-sm-2 pt-2">
                        <div class="select-holder">
                          <b-form-select
                            id="RecipTitle"
                            name="RecipTitle"
                            v-model.trim="$v.recipient.title.$model"
                            :options="titleOptions"
                            :state="validateState('recipient', 'title')"
                            @change="touchField(recipient.title)"
                          >
                          </b-form-select>
                          <div
                            class="alert alert-danger m-b-0"
                            v-if="
                              $v.recipient.title.$dirty &&
                                !$v.recipient.title.required
                            "
                          >
                            Please select a title.
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-4 pt-2">
                        <b-form-input
                          id="RecipFirstName"
                          style=" border-radius:5px"
                          v-model.trim="$v.recipient.firstname.$model"
                          placeholder="Firstname"
                          :state="validateState('recipient', 'firstname')"
                          @change="touchField(recipient.firstname)"
                        >
                        </b-form-input>
                        <div
                          class="alert alert-danger m-b-0"
                          v-if="
                            $v.recipient.firstname.$dirty &&
                              !$v.recipient.firstname.required
                          "
                        >
                          Field is required
                        </div>
                      </div>
                    </b-row>

                    <!-- Gift Recipient Last Name -->
                    <b-row
                      v-if="
                        closingOption === 'GIFTCARD' &&
                          $route.params.wishlistType === 'giftlist' &&
                          isForMe === 'false'
                      "
                      class="pb-3"
                    >
                      <div class="col-sm-4">
                        <label for="LastName"
                          >Recipient Last Name<span class="required"
                            >*</span
                          ></label
                        >
                      </div>
                      <div class="col-sm-6">
                        <b-form-input
                          id="RecipLastname"
                          style=" border-radius:5px"
                          v-model="$v.recipient.surname.$model"
                          placeholder="Surname"
                          :state="validateState('recipient', 'surname')"
                          @change="touchField(recipient.surname)"
                        >
                        </b-form-input>
                        <div
                          class="alert alert-danger m-b-0"
                          v-if="
                            $v.recipient.surname.$dirty &&
                              !$v.recipient.surname.required
                          "
                        >
                          Field is required
                        </div>
                      </div>
                    </b-row>

                    <!-- Gift Recipient Email -->
                    <b-row
                      v-if="
                        closingOption === 'GIFTCARD' &&
                          $route.params.wishlistType === 'giftlist' &&
                          isForMe === 'false'
                      "
                      class="pb-3"
                    >
                      <div class="col-sm-4">
                        <label for="Email"
                          >Recipient Email Address<span class="required"
                            >*</span
                          ></label
                        >
                      </div>
                      <div class="col-sm-6">
                        <b-form-input
                          type="email"
                          placeholder="Email Address"
                          v-model.trim="$v.recipient.email.$model"
                          :state="validateState('recipient', 'email')"
                          @change="touchField(recipient.email)"
                        ></b-form-input>
                        <div
                          class="alert alert-danger m-b-0"
                          v-if="$v.email.$dirty && !$v.email.required"
                        >
                          Field is required
                        </div>
                        <div
                          class="alert alert-danger m-b-0"
                          v-if="!$v.email.email || !$v.email.minLength"
                        >
                          Must be a valid e-mail (e.g. example@example.com)
                        </div>
                      </div>
                    </b-row>

                    <!-- Gift Recipient Email Confirm-->
                    <b-row
                      v-if="
                        closingOption === 'GIFTCARD' &&
                          $route.params.wishlistType === 'giftlist' &&
                          isForMe === 'false'
                      "
                      class="pb-3"
                    >
                      <div class="col-sm-4">
                        <label for="Email"
                          >Recipient Email Confirm<span class="required"
                            >*</span
                          ></label
                        >
                      </div>
                      <div class="col-sm-6">
                        <b-form-input
                          type="email"
                          placeholder="Confirm Email Address"
                          v-model.trim="$v.recipient.emailconfirm.$model"
                          :state="validateState('recipient', 'emailconfirm')"
                          @change="touchField(recipient.emailconfirm)"
                        ></b-form-input>
                        <div
                          class="alert alert-danger m-b-0"
                          v-if="
                            $v.recipient.emailconfirm.$dirty &&
                              !$v.recipient.emailconfirm.required
                          "
                        >
                          Field is required
                        </div>
                        <div
                          class="alert alert-danger m-b-0"
                          v-if="!$v.recipient.emailconfirm.sameAs"
                        >
                          Email Address does not match
                        </div>
                      </div>
                    </b-row>

                    <!-- Gift Recipient Message From Us -->
                    <b-row
                      v-if="
                        closingOption === 'GIFTCARD' &&
                          $route.params.wishlistType === 'giftlist' &&
                          isForMe === 'false'
                      "
                      class="pb-3"
                    >
                      <div class="col-sm-4">
                        <label for="Email">Message from you</label>
                      </div>
                      <div class="col-sm-6">
                        <b-form-textarea
                          rows="6"
                          style=" border-radius:5px; margin-top:8px"
                          id="input-7"
                          placeholder="Message from you"
                          v-model="recipient.message"
                        >
                        </b-form-textarea>
                      </div>
                    </b-row>

                    <!-- Gift Recipient Select Later Date -->
                    <b-row
                      v-if="
                        closingOption === 'GIFTCARD' &&
                          $route.params.wishlistType === 'giftlist' &&
                          isForMe === 'false'
                      "
                      class="pb-3"
                    >
                      <div class="col-sm-4">
                        <!-- <label for="Email">Message from you</label> -->
                      </div>
                      <div class="col-sm-4">
                        <b-form-checkbox
                          id="checkbox-1"
                          v-model="recipient.scheduled"
                          name="scheduled_date"
                          value="true"
                          unchecked-value="false"
                        >
                          Send Gift Card at a later date?
                        </b-form-checkbox>
                      </div>
                    </b-row>

                    <!-- Gift Recipient The Later Date -->
                    <b-row
                      v-if="
                        closingOption === 'GIFTCARD' &&
                          $route.params.wishlistType === 'giftlist' &&
                          recipient.scheduled === 'true' &&
                          isForMe === 'false'
                      "
                      class="pb-3"
                    >
                      <div class="col-sm-4">
                        <label for="Email"
                          >Gift Card Send Date<span class="required"
                            >*</span
                          ></label
                        >
                      </div>
                      <div class="col-sm-4">
                        <b-form-datepicker
                          reset-button
                          reset-value=""
                          locale="en"
                          :min="min"
                          close-button
                          v-model.trim="$v.recipient.scheduled_pretty.$model"
                          :state="
                            validateState('recipient', 'scheduled_pretty')
                          "
                          @change="touchField($v.recipient.scheduled_pretty)"
                          aria-describedby="input-13-live-feedback"
                          :date-format-options="{
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          }"
                        ></b-form-datepicker>
                        <div
                          class="alert alert-danger mb-0"
                          v-if="
                            $v.recipient.scheduled_pretty.$dirty &&
                              !$v.recipient.scheduled_pretty.required
                          "
                        >
                          Field is required
                        </div>
                      </div>
                    </b-row>

                    <!-- Email Alert -->
                    <b-row>
                      <div class="col-sm-12">
                        <hr class="visible-xs" />
                      </div>

                      <div class="col-sm-4">
                        <label>Email Alert</label>
                      </div>
                      <div class="col-sm-7 well" id="register-well">
                        <div role="alert">
                          <p>
                            <small
                              >Would you like us to alert you each time your
                              guests contribute?</small
                            >
                          </p>
                          <b-col class="px-0" sm="12">
                            <b-form-checkbox
                              id="tfEmails"
                              v-model.trim="tfEmails"
                              name="tfEmails"
                              value="yes"
                              unchecked-value="'N'"
                              size="sm"
                              class="float-start"
                            >
                              Yes, I would like an email alert
                            </b-form-checkbox>
                          </b-col>
                        </div>
                      </div>
                    </b-row>

                    <!-- Terms and Conditions Radio -->
                    <b-row>
                      <div class="col-sm-12">
                        <hr class="visible-xs" />
                      </div>

                      <!-- Terms and Conditions -->
                      <div class="col-sm-4">
                        <label
                          >Terms &amp; Conditions
                          <span class="required">*</span></label
                        >
                      </div>
                      <div class="col-sm-7 well" id="register-well">
                        <div class="" role="alert">
                          <div class="radio radio-custom">
                            <b-col
                              style="padding-left:0px; padding-right:0px;"
                              sm="12"
                            >
                              <b-form-checkbox
                                id="checkbox-1"
                                v-model="tAndC"
                                name="tAndC"
                                value="yes"
                                unchecked-value="''"
                                size="sm"
                                :state="validateState('tAndC')"
                                @change="touchField($v.tAndC)"
                              >
                                Please tick here to confirm you have read and
                                agree with the
                                <a
                                  v-if="
                                    $route.params.wishlistType === 'honeymoon'
                                  "
                                  data-bs-toggle="modal"
                                  data-bs-target="#weddModal"
                                  >Terms And Conditions</a
                                >
                                <a
                                  v-if="
                                    $route.params.wishlistType === 'giftlist'
                                  "
                                  data-bs-toggle="modal"
                                  data-bs-target="#celebModal"
                                  >Terms And Conditions</a
                                >
                              </b-form-checkbox>
                            </b-col>
                          </div>
                        </div>
                      </div>
                    </b-row>

                    <!-- Terms and Conditions Name Input -->
                    <b-row v-if="tAndC === 'yes'">
                      <div class="col-sm-4">
                        <label for="termsName"
                          >Name of person who agreed to the Terms &amp;
                          Conditions<span class="required">*</span></label
                        >
                      </div>
                      <div class="col-sm-7">
                        <b-form-input
                          v-model.trim="tAndCName"
                          placeholder="Full Name"
                          :state="validateState('tAndCName')"
                          @change="touchField($v.tAndCName)"
                        ></b-form-input>
                      </div>
                    </b-row>
                  </div>

                  <!-- Submit -->
                  <b-row>
                    <b-col sm="5"></b-col>
                    <b-col sm="2" class="pr-0 pb-4 text-center">
                      <b-button
                        v-if="$route.params.wishlistType === 'honeymoon'"
                        style="background-color: pink; color: white; border: none; border-radius: 0% !important;"
                        class="btn btn-primary mt-2"
                        type="submit"
                        :disabled="disabled"
                        @click="onSubmit"
                      >
                        Submit
                      </b-button>
                      <b-button
                        v-if="$route.params.wishlistType === 'giftlist'"
                        style="background-color: orange; color: white; border: none; border-radius: 0% !important;"
                        class="btn btn-primary mt-2"
                        type="submit"
                        :disabled="disabled"
                        @click="onSubmit"
                      >
                        Submit
                      </b-button>
                    </b-col>
                  </b-row>
                  <!-- $Dirty Form Error -->
                  <b-row class="pb-3">
                    <b-col sm="4"></b-col>
                    <b-col sm="8">
                      <div
                        class="alert alert-danger mt-3 m-b-0 text-center"
                        v-if="formNotValid"
                      >
                        Please complete all required fields
                      </div>
                    </b-col>
                  </b-row>

                  <!-- Error/Success Handling -->
                  <div>
                    <b-alert
                      variant="success"
                      show
                      v-if="
                        showSuccess &&
                          $route.params.wishlistType === 'honeymoon'
                      "
                      style="padding: 15px"
                    >
                      Thank you for registering for the Honeymoon Wishlist,
                      we'll start working on your request straight away. You'll
                      be able to log into your website in 24 hours using your
                      unique booking reference,
                      {{ registerResponse.reference }} along with your client
                      number, {{ registerResponse.client_number }}.
                    </b-alert>

                    <b-alert
                      variant="success"
                      show
                      v-if="
                        showSuccess && $route.params.wishlistType === 'giftlist'
                      "
                      style="padding: 15px"
                    >
                      Thank you for registering for the Celebration Wishlist,
                      we'll start working on your request straight away. You'll
                      be able to log into your website in 24 hours using your
                      unique booking reference,
                      {{ registerResponse.reference }} along with your client
                      number, {{ registerResponse.client_number }}.
                    </b-alert>

                    <b-alert
                      variant="danger"
                      show
                      v-if="showError"
                      style="padding: 15px"
                    >
                      There was a problem registering your interest please call
                      us on .<br />
                    </b-alert>
                  </div>
                </b-form>
              </b-col>
            </section>
          </div>
        </section>
      </div>
      <!-- weddModal -->
      <div
        class="modal"
        id="weddModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="preview"
        aria-hidden="true"
        size="xl"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content" id="gc_preview">
            <!-- <div class="modal-header">
                      <h4 class="modal-title" id="myModalLabel" style="margin-top:1.5% !important;">Administration of your Trailfinders Honeymoon Wishlist</h4>
                  </div> -->
            <div class="modal-body">
              <div class="inner">
                <div class="inner-content">
                  <button
                    type="button"
                    class="btn-close float-end"
                    style=" margin: 0;"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                  <h2
                    class="text-center pb-3"
                    style="font-family: 'Alegreya', Georgia, Time Roman, serif;font-style: italic; font-weight:400;"
                  >
                    Terms and Conditions of your Trailfinders Honeymoon Wishlist
                  </h2>
                  <p>
                    We are happy to provide complimentary guest cards for you to
                    include with your invitations which can be ordered online.
                  </p>
                  <p>
                    All Honeymoon Wishlist contributions from your family and
                    friends will be deposited into one account. When opening
                    your Honeymoon Wishlist you opted whether you wish to
                    receive your contributions in the form of a Trailfinders
                    electronic Gift Card or as a payment towards your
                    Trailfinders booking. If you wish to change your preference,
                    please
                    <strong><a :href="`tel:${telNo}`" :data-ga4-label="telNo === '0207 368 1404' ? 'wishlist_admin' : null" :data-ga4-category="telNo === '0207 368 1404' ? 'text_link' : null">call</a></strong> the
                    Wishlist admin team.
                  </p>
                  <p>
                    Your guest contributions or TF Gift Cards are valid towards
                    all Trailfinders products with the exception of a small
                    number of associated services (i.e. Travel Clinic, foreign
                    exchange and airport/hotel parking where payment must be
                    made direct to the supplier).
                  </p>
                  <p>
                    No monies held in a TF Honeymoon Wishlist can be transferred
                    or used until the list has been closed.
                  </p>

                  <h2 class="text-center pb-3">Your Guest Contributions</h2>
                  <p>
                    It's easy for your friends and family to contribute to your
                    Trailfinders Honeymoon Wishlist – online, in person, by
                    telephone or by post subject to Trailfinders normal terms
                    and conditions. For payments by cheque six working days are
                    required for clearance, therefore if a guest contributes by
                    cheque the day before your Honeymoon Wishlist closes we will
                    need to wait for it to clear before closing your account.
                  </p>

                  <h2 class="text-center pb-3">
                    Honeymoon or pending itineraries
                  </h2>
                  <p>
                    If you have notified us of your Trailfinders booking we will
                    automatically transfer the total value of contributions to
                    this booking.
                  </p>
                  <p>
                    If the final payment date for the booking is before the
                    closing date for the Wishlist, which is often the case with
                    honeymoon bookings, you will need to pay the balance in full
                    and await the monies from the list. Your contributions will
                    be credited to the booking when the Wishlist has been closed
                    (generally a week after the closing date).
                  </p>
                  <p>
                    Trailfinders can only refund Wishlist monies to the original
                    form of payment on the booking. Bear in mind if multiple
                    payments have been used we can only credit to the amount
                    spent via each method of payment. Therefore please ensure
                    you have paid the booking with the card/account you wish to
                    be credited.
                  </p>
                  <p>
                    Any excess funds from the Wishlist will be credited as a
                    Trailfinders Electronic Gift Card.
                  </p>

                  <h2 class="text-center pb-3">Gift Cards</h2>
                  <p>
                    Trailfinders electronic Gift Cards are valid indefinitely
                    and can be redeemed against products and services paid
                    direct to Trailfinders at any of our travel centres.
                  </p>
                  <p>
                    Trailfinders Gift Cards cannot be exchanged for cash and any
                    unused credit will remain on the card and can be used
                    towards payment of future travels.
                  </p>
                  <p>
                    Gift Card monies are protected by the Trailfinders Trust
                    Account.
                  </p>
                  <p v-if="isUK">
                    Sterling Gift Cards are not redeemable in Trailfinders
                    Ireland travel centres. If you wish to receive contributions
                    in Euros for use in Trailfinders Ireland please visit
                    <a href="http://www.trailfinders.ie/wishlist"
                      >www.trailfinders.ie/wishlist</a
                    >.
                  </p>
                  <p v-if="isIe">
                    Euro gift cards are not redeemable in Trailfinders travel
                    centres. If you wish to receive contributions in pounds for
                    use in Trailfinders UK please visit
                    <a href="http://www.trailfinders.com/wishlist"
                      >trailfinders.com/wishlist</a
                    >.
                  </p>

                  <h2 class="text-center pb-3">Cancellation</h2>
                  <p>
                    In the unlikely event you need to cancel your Wishlist
                    please contact our Wishlist team on
                    <strong
                      ><a :href="`tel:${telNo}`" :data-ga4-label="telNo === '0207 368 1404' ? 'wishlist_admin' : null" :data-ga4-category="telNo === '0207 368 1404' ? 'text_link' : null">{{ telNo }}</a></strong
                    >/wishlist@trailfinders.com. This will enable us to close
                    the Wishlist to prevent further contributions.
                  </p>
                  <p>
                    In the event that your holiday is cancelled we can either
                    transfer the funds to a new booking if you have chosen to
                    offset the balance or issue you with an Electronic Gift card
                    which is valid indefinitely for future travel. It is not
                    possible to exchange to any other form of payment.
                    Contributions are provided in good faith to cover elements
                    of your honeymoon and it is our legal duty to fulfil the
                    Contributor’s expectations and wishes.
                  </p>
                  <p>
                    If you would like us to refund the individual contributions
                    made we will make an administration charge of
                    {{ currency }}100 to cover our costs.
                  </p>
                  <p>
                    These Terms and Conditions are applicable at the time you
                    register your Wishlist with Trailfinders.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- celebModal -->
      <div
        class="modal"
        id="celebModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="preview"
        aria-hidden="true"
        size="xl"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content" id="gc_preview">
            <div class="modal-body">
              <div class="inner">
                <div class="inner-content">
                  <button
                    type="button"
                    class="btn-close float-end"
                    style=" margin: 0;"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                  <h2
                    class="text-center pb-3"
                    style="font-family: 'Alegreya', Georgia, Time Roman, serif;font-style: italic; font-weight: 400;"
                  >
                    Administration of your Trailfinders Celebration Wishlist
                  </h2>
                  <p>
                    Once you have registered, either online or by telephone, we
                    will open your Celebration Wishlist and unless otherwise
                    notified it will stay open for one week after your
                    celebration.
                  </p>

                  <p>
                    We are happy to provide complimentary guest cards for you to
                    include with your invitations.
                    <strong
                      ><a :href="`tel:${telNo}`" :data-ga4-label="telNo === '0207 368 1404' ? 'wishlist_admin' : null" :data-ga4-category="telNo === '0207 368 1404' ? 'text_link' : null">{{ telNo }}</a></strong
                    >
                    and please be aware there will be an administration fee of
                    {{ currency }}15.
                  </p>

                  <p>
                    All Wishlist contributions from your family and friends will
                    be deposited into one account. When opening your Celebration
                    Wishlist you can decide whether you wish to receive your
                    contributions in the form of a Trailfinders gift card or as
                    a payment towards your Trailfinders booking. Within 2 weeks
                    of your Wishlist closing we will send you a summary of all
                    guest contributions along with their personal messages. You
                    can also view these on your personalised website anytime,
                    online.
                  </p>

                  <p>
                    Your guest contributions or TF Gift Cards are valid towards
                    all Trailfinders products with the exception of a small
                    number of associated services (ie foreign exchange and
                    airport/hotel parking where payment must be made direct to
                    the supplier).
                  </p>

                  <p>
                    No monies held in a TF Celebration Wishlist can be
                    transferred or used until the list has been closed.
                  </p>

                  <h2>Your guest contributions</h2>

                  <p>
                    The minimum contribution towards your Celebration Wishlist
                    is {{ currency }}10 and this increases in multiples of
                    {{ currency }}5 – i.e. {{ currency }}25, {{ currency }}30
                    etc. The good news is there is no maximum contribution!
                  </p>

                  <p>
                    It&#39;s easy for your friends and family to contribute to
                    your Trailfinders Celebration Wishlist – online, in person,
                    by telephone or by post subject to Trailfinders normal terms
                    and conditions. For payments by cheque six working days are
                    required for clearance, therefore if a guest contributes by
                    cheque the day before your Celebration Wishlist closes we
                    will need to wait for it to clear before closing your
                    account.
                  </p>

                  <h2 class="text-center pb-3">Gift Cards</h2>
                  <p>
                    Trailfinders electronic gift cards are valid indefinitely
                    and can be redeemed against products and services paid
                    direct to Trailfinders at any of our travel centres.
                  </p>
                  <p>
                    Trailfinders gift cards cannot be exchanged for cash and any
                    unused credit will remain on the card and can be used
                    towards payment of future travels.
                  </p>
                  <p>
                    Gift Card monies are protected by the Trailfinders Trust
                    Account.
                  </p>
                  <p v-if="isUK">
                    Sterling gift cards are not redeemable in Trailfinders
                    Ireland travel centres. If you wish to receive contributions
                    in Euros for use in Trailfinders Ireland please visit
                    <a href="http://www.trailfinders.ie/wishlist"
                      >www.trailfinders.ie/wishlist</a
                    >.
                  </p>
                  <p v-if="isIe">
                    Euro gift cards are not redeemable in Trailfinders UK travel
                    centres. If you wish to receive contributions in pounds for
                    use in Trailfinders UK please visit
                    <a href="http://www.trailfinders.com/wishlist"
                      >trailfinders.com/wishlist</a
                    >.
                  </p>

                  <h2 class="text-center pb-3">
                    Honeymoon or pending itineraries
                  </h2>
                  <p>
                    If you have notified us of your Trailfinders booking we will
                    automatically transfer the total value of contributions to
                    this booking.
                  </p>
                  <p>
                    If the final payment date for the booking is before the
                    closing date for the Wishlist, which is often the case with
                    honeymoon bookings, you will need to pay the balance in full
                    and await the monies from the list. Your contributions will
                    be credited to the booking when the Wishlist has been closed
                    (generally a week after the closing date).
                  </p>
                  <p>
                    Trailfinders will refund Wishlist monies to the original
                    form of payment on the booking (and not alternative
                    cards/accounts). Bear in mind if multiple payments have been
                    used we can only credit to the amount spent via each method
                    of payment. Therefore please ensure you have paid the
                    booking with the card/account you wish to be credited.
                  </p>

                  <h2 class="text-center pb-3">Cancellation</h2>

                  <p>
                    In the unlikely event you need to cancel your Wishlist
                    please contact our Wishlist team on {{ telNo }}. This will
                    enable us to close the Wishlist to prevent further
                    contributions.
                  </p>
                  <p>
                    If you would like us to refund the individual contributions
                    made we will make an administration charge of
                    {{ currency }}75 to cover our costs.
                  </p>
                  <p>
                    These Terms and Conditions are applicable at the time you
                    register your list with Trailfinders.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  </section>
</template>

<script>
import moment from "moment";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  numeric,
  requiredIf,
  sameAs,
} from "vuelidate/lib/validators";
import { getPostcode, submitRegisterForm } from "../../services/api";
import Autoaddress from "@autoaddress.ie/autoaddress-vue/src/Autoaddress";
export default {
  mixins: [validationMixin],
  components: {
    Autoaddress,
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const minDate = new Date(today);
    const maxDate = new Date(now.getMonth() + 1);

    return {
      meta: {
        loaded: true,
      },
      noBookRef: false,
      addressFound: false,
      disabled: false,
      isIe: false,
      isUK: true,
      ref: ".com",
      max: maxDate,
      day: null,
      month: null,
      year: null,
      min: minDate,
      minCutOffDate: null,
      isForMe: null,
      site: "UK",
      titleOrg: null,
      firstnameOrg: "",
      lastnameOrg: "",
      title: null,
      firstname: "",
      lastname: "",
      title_1: null,
      firstname_1: "",
      lastname_1: "",
      title_2: null,
      firstname_2: "",
      lastname_2: "",
      title_3: null,
      firstname_3: "",
      lastname_3: "",
      title_4: null,
      firstname_4: "",
      lastname_4: "",
      title2: null,
      firstname2: "",
      lastname2: "",
      email: "",
      shortDay: null,
      shortMonth: null,
      shortYear: null,
      longDay: null,
      longMonth: null,
      longYear: null,
      telephone: null,
      isAddressUk: "",
      isAddressIe: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      postCode: "",
      postcodeSearch: "",
      postcode: "",
      weddingDate: "",
      cutOffDate: "",
      closingOption: "",
      bookingRef: "",
      tfEmails: "",
      tAndC: "",
      tAndCName: "",
      wishlistType: null,
      registerResponse: null,
      domain: null,
      telNo: null,
      currency: null,
      currency_code: null,
      showError: false,
      showSuccess: false,
      formNotValid: false,
      colWidth: 4,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      recipient: {
        title: null,
        firstname: "",
        surname: "",
        email: "",
        emailconfirm: "",
        gift: "N",
        scheduled: "false",
        scheduled_pretty: null,
        message: "",
      },
      wishlistOptions: [
        { text: "Select Wishlist Type", value: null },
        "Birthday",
        "Blessing",
        "Anniversary",
        "Engagement",
        "Retirement",
        "Vow Renewal",
        { text: "Other Celebrations", value: "Celebration" },
      ],
      postcodeDropdown: false,
      postcodeResult: [],
      date: null,
      numberOfFields: 1,
      titleOptions: [
        { text: "Select Title", value: null },
        "Mrs",
        "Miss",
        "Ms",
        "Mr",
        "Dr",
        "Other",
      ],
    };
  },
  validations: {
    titleOrg: {
      required: requiredIf(function() {
        return this.isForMe === "false";
      }),
    },
    firstnameOrg: {
      required: requiredIf(function() {
        return this.isForMe === "false";
      }),
    },
    lastnameOrg: {
      required: requiredIf(function() {
        return this.isForMe === "false";
      }),
    },
    title: {
      required: required,
    },
    firstname: {
      required: required,
    },
    lastname: {
      required: required,
    },
    title2: {
      required: requiredIf(function() {
        return this.$route.params.wishlistType === "honeymoon";
      }),
    },
    firstname2: {
      required: requiredIf(function() {
        return this.$route.params.wishlistType === "honeymoon";
      }),
    },
    lastname2: {
      required: requiredIf(function() {
        return this.$route.params.wishlistType === "honeymoon";
      }),
    },
    email: {
      required: required,
      email: email,
      minLength: minLength(3),
    },
    telephone: {
      required: required,
      numeric,
    },
    postCode: {
      required: required,
    },
    addressLine1: {
      required: required,
      minLength: minLength(3),
    },
    addressLine2: {
      required: required,
      minLength: minLength(2),
    },
    addressLine3: {
      required: required,
      minLength: minLength(1),
    },
    tAndC: {
      required: required,
    },
    tAndCName: {
      required: required,
    },
    isForMe: {
      required: requiredIf(function() {
        return this.$route.params.wishlistType === "giftlist";
      }),
    },
    isAddressUk: {
      required: requiredIf(function() {
        return this.isUK === true;
        
      }),
    },
    isAddressIe: {
      required: requiredIf(function() {
        return this.isIe === true;
      }),
    },
    weddingDate: {
      required: required,
    },
    cutOffDate: {
      required: required,
    },
    closingOption: {
      required: required,
    },
    wishlistType: {
      required: requiredIf(function() {
        return this.$route.params.wishlistType === "giftlist";
      }),
    },
    bookingRef: {
      required: requiredIf(function() {
        return (
          this.noBookRef === false && this.closingOption === "addToBooking"
        );
      }),
    },
    noBookRef: {
      required: requiredIf(function() {
        return (
          this.noBookRef === false && this.closingOption === "addToBooking"
        );
      }),
    },
    recipient: {
      title: {
        required: requiredIf(function() {
          return this.closingOption === "GIFTCARD" && this.isForMe === false;
        }),
      },
      firstname: {
        required: requiredIf(function() {
          return this.closingOption === "GIFTCARD" && this.isForMe === false;
        }),
      },
      surname: {
        required: requiredIf(function() {
          return this.closingOption === "GIFTCARD" && this.isForMe === false;
        }),
      },
      email: {
        required: requiredIf(function() {
          return this.closingOption === "GIFTCARD" && this.isForMe === false;
        }),
        email: email,
        minLength: minLength(3),
      },
      emailconfirm: {
        required: requiredIf(function() {
          return this.closingOption === "GIFTCARD" && this.isForMe === false;
        }),
        email: email,
        minLength: minLength(3),
        sameAs: sameAs("email"),
      },
      scheduled_pretty: {
        required: requiredIf(function() {
          return this.recipient.scheduled === "true" && this.isForMe === false;
        }),
      },
    },
  },
  methods: {
    onClicker(event) {
      if (event === "plus" && this.numberOfFields + 1 < 4) {
        this.numberOfFields = this.numberOfFields + 1;
      } else {
        if (this.numberOfFields > 0) {
          this.numberOfFields = this.numberOfFields - 1;
        }
      }
    },
    postcodeLookup() {
      getPostcode(this.postcodeSearch).then((response) => {
        if (response.data.count) {
          this.postcodeDropdown = true;
          this.postcodeResult = response.data.results;
          this.addressFound = true;
        } else {
          this.addressFound = true;
          this.postcodeResult = [];
          this.postcodeDropdown = false;
        }
      });
    },
    handleSelection(data) {
      // Select data and split into lines
      let address = data.split(",");
      // Populate input fields
      this.addressLine1 = address[0].trim();
      this.addressLine2 = address[1];
      this.addressLine3 = address[2];
      // this.contactForm.addressLine4 = address[3]
      this.postCode = this.postcodeSearch.toUpperCase();
      // Close dropdown
      this.postcodeDropdown = false;
      // Set postcode finder input back to empty
      this.postcodeSearch = "";
    },
    touchField: function(field) {
      if (field && typeof field.touch === "function") {
        field.touch();
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    async onSubmit(e) {
      this.showError = false;
      this.showSuccess = false;
      this.formNotValid = false;
      this.disabled = false;
      e.preventDefault();
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.disabled = true;
        let parsedDate = Date.parse(this.cutOffDate);
        const cutODate = new Date(parsedDate);
        this.shortDay = moment(cutODate).format("D");
        this.shortMonth = moment(cutODate).format("MM");
        this.shortYear = moment(cutODate).format("YYYY");
        const days = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
        this.longDay = days[cutODate.getDay()];
        this.longMonth = moment(cutODate).format("MMMM");
        this.longYear = moment(cutODate).format("YYYY");
        let dataObj = {
          address: this.addressLine1,
          address2: this.addressLine2,
          address3: this.addressLine3,
          post_code: this.postCode,
          created_by: "external",
          email: this.email,
          email_alert: this.tfEmails,
          person_01: {
            title: this.title,
            first_name: this.firstname,
            last_name: this.lastname,
          },
          person_02: {
            title: this.title2,
            first_name: this.firstname2,
            last_name: this.lastname2,
          },
          addresslookup: {
            postcode: this.postCode,
          },
          phone: this.telephone,
          sf_wedding_cutoff: this.formatDate(this.cutOffDate),
          sf_wedding_date: this.formatDate(this.weddingDate),
          wedding_date_iso: this.convertToIso(this.weddingDate),
          terms: true,
          terms_name: this.tAndCName,
          wedding_type: "normal",
          payment_options: this.closingOption,
          wedding_cutoff: `${this.longDay}, ${this.longMonth} ${this.shortDay}, ${this.shortYear}`,
          wedding_cutoff_iso: cutODate.getTime(),

          date: {
            month: this.shortMonth,
            day: this.shortDay,
            year: this.shortYear,
          },
          site_info: {
            domain: this.domain,
            telno: this.telNo,
            currency: this.currency,
            currency_code: this.currency_code,
          },
          ppc: "",
          src: "",
        };
        if (window.siteVar && window.siteVar.payPerClick) {
          dataObj.ppc = window.siteVar.payPerClick;
        }
        if (this.isIe) {
          dataObj.addresslookup.selectedAddress = this.postcodeResult.postalAddress;
        } else {
          dataObj.addresslookup.selectedAddress = this.postcodeResult[0].suggestion;
        }
        if (this.$route.params.wishlistType === "giftlist") {
          dataObj.person_02 = {};
          if (this.title_2 === null) {
            dataObj.person_02.title = "";
          } else {
            dataObj.person_02.title = this.title_2;
          }
          dataObj.person_02.first_name = this.firstname_2;
          dataObj.person_02.last_name = this.lastname_2;
        }

        if (this.firstname_3 && this.lastname_3) {
          dataObj.person_03 = {};
          dataObj.person_03.title = this.title_3;
          dataObj.person_03.first_name = this.firstname_3;
          dataObj.person_03.last_name = this.lastname_3;
        }

        if (this.firstname_4 && this.lastname_4) {
          dataObj.person_04 = {};
          dataObj.person_04.title = this.title_4;
          dataObj.person_04.first_name = this.firstname_4;
          dataObj.person_04.last_name = this.lastname_4;
        }
        if (
          this.$route.params.wishlistType === "giftlist" &&
          this.isForMe === false
        ) {
          dataObj.organiser = true;
          dataObj.oraniser_01 = {};
          dataObj.oraniser_01.title = this.titleOrg;
          dataObj.oraniser_01.first_name = this.firstnameOrg;
          dataObj.oraniser_01.last_name = this.lastnameOrg;
          if (this.closingOption === "GIFTCARD") {
            dataObj.recipient = {};
            dataObj.recipient.title = this.recipient.title;
            dataObj.recipient.first_name = this.recipient.firstname;
            dataObj.recipient.last_name = this.recipient.surname;
            dataObj.recipient.email = this.recipient.email;
            dataObj.recipient.scheduled = this.recipient.scheduled;
            dataObj.recipient.scheduled_pretty = this.recipient.scheduled_pretty;
            dataObj.recipient.message = this.recipient.message;
          }
        }
        if (this.$route.params.wishlistType === "honeymoon") {
          (dataObj.tf100_active = false), (dataObj.src = "");
        }

        if (this.closingOption === "BOOKING") {
          if (this.bookingRef !== "" && this.noBookRef === false) {
            dataObj.payment_options_post = this.bookingRef;
          } else if (this.noBookRef === true) {
            dataObj.payment_options_post = "TBA";
          }
        } else {
          dataObj.payment_options_post = "GIFTCARD";
        }
        if (this.$route.params.wishlistType === "giftlist") {
          dataObj.type = this.wishlistType;
          dataObj.wishlist_type = "giftlist";
        } else {
          dataObj.type = "Wedding";
          dataObj.wishlist_type = "wishlist";
        }
        let res = await submitRegisterForm(dataObj.wishlist_type, dataObj);
        if (res.error) {
          this.showError = true;
        } else {
          this.registerResponse = res.data;
          this.showSuccess = true;
        }
      } else {
        this.formNotValid = true;
      }
    },
    foundAddress(addressInfo) {
      if (addressInfo.postalAddress) {
        if (addressInfo.postalAddress[1]) {
          this.addressLine1 = addressInfo.postalAddress[1];
        }
        if (addressInfo.postalAddress[2]) {
          this.addressLine2 = addressInfo.postalAddress[2];
        }
        if (addressInfo.postalAddress[3]) {
          this.addressLine3 = addressInfo.postalAddress[3];
        }
        if (addressInfo.postcode) {
          this.postCode = addressInfo.postcode.toUpperCase();
        }
        this.postcodeResult = addressInfo;
        this.addressFound = true;
      } else {
        this.addressFound = true;
      }
    },
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      if (window.innerWidth < 790) {
        this.vertical = true;
      } else {
        this.vertical = false;
      }
      if (window.innerWidth <= "1367") {
        this.colWidth = "12";
      } else {
        this.colWidth = "12";
      }
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    convertToIso(_date) {
      let formatUSADate = moment(_date).format("MM/DD/YYYY");
      let _time = new Date(formatUSADate);
      _time.setHours(24);
      return _time.getTime() - 1;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    minCutOff() {
      return moment(this.weddingDate)
        .add(1, "weeks")
        .format("YYYY-MM-DD");
    },
    maxCutOff() {
      return moment(this.weddingDate)
        .add(1, "months")
        .format("YYYY-MM-DD");
    },
  },
  mounted() {
    if (
      this.$route.params.wishlistType !== "honeymoon" &&
      this.$route.params.wishlistType !== "giftlist"
    ) {
      this.$router.push({ path: `/` });
    }
    
    this.meta.loaded = true;
    if (window.location.toString().indexOf("trailfinders.ie") > 0 ||  window.siteVar.referer == 'IE')  {
      this.isIe = true;
      this.isUK = false;
      this.ref = ".ie";
      this.currency = "€";
      this.currency_code = "EUR";
      this.domain = "ie";
      this.telNo = "01 881 4990";
      this.site = "IE";
    } else {
      this.isIe = false;
      this.isUK = true;
      this.ref = ".com";
      this.domain = "com";
      this.currency = "£";
      this.currency_code = "GBP";
      this.site = "UK";
      if (this.$route.params.wishlistType === "giftlist") {
        this.telNo = "020 7408 9008";
      } else {
        this.telNo = "0207 368 1404";
      }
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize());
    });
  },
};
</script>
<style>
@media only screen and (max-width: 1040px) {
  #register-well {
    margin-left: 0px;
    margin-right: 0px;
  }
}
.express-vue-temp a {
  color: black;
  text-decoration: none;
  background-color: transparent;
  font-weight: 600;
}
</style>
<style lang="scss">
.b-form-datepicker .b-calendar-grid-body {
  .btn {
    padding: 9px 0 !important;
    width: 32px;
    height: 32px !important;
  }
  .col {
    margin: inherit;
  }
  .small {
    line-height: normal;
  }
}
</style>
<style lang="scss">
.post-code-results {
  position: relative;
  width: 100%;
  background-color: #fff;
  height: 150px;
  overflow-y: scroll;
  -webkit-box-shadow: 2px 3px 5px 0px rgba(0, 0, 0, 0.33);
  -moz-box-shadow: 2px 3px 5px 0px rgba(0, 0, 0, 0.33);
  box-shadow: 2px 3px 5px 0px rgba(0, 0, 0, 0.33);

  ul {
    list-style: none;
    position: relative;
    z-index: 1;
    background-color: white;
    padding-left: 0;
  }
  li {
    margin: 5px 0;
    padding: 8px !important;
    text-align: left;
  }
  li:hover {
    background-color: #ffa409;
    cursor: pointer;
  }
}
</style>
<style>
.inner-content {
  padding: 50px;
  align-content: center;
  padding-top: 2%;
}

.autoaddress-control {
  max-width: 650px;
  margin: 10px 0;
  font-size: 15px;
  color: #777c89;
  font-family: inherit;
  position: relative;
  line-height: normal;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.autoaddress-control > .autoaddress-text-box {
  outline: 0;
  border: 0;
  border: 1px solid #dedede;
  border-radius: 3px;
  color: #999999;
  line-height: normal;
  line-height: 52px\9;
  height: 55px;
  width: 80%;
  box-sizing: border-box;
  background: #fff;
  font-size: 16px;
  color: #666;
  margin: 0;
  padding: 0 10px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  float: left;
}
.autoaddress-control > .autoaddress-button {
  background-color: orange;
  border: 1px solid orange;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
  font-size: 20px;
  font-weight: 400;
  line-height: normal;
  height: 55px;
  text-align: center;
  vertical-align: middle;
  border-radius: 4px;
  width: 20%;
  margin: 0;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  clear: right;
  position: relative;
  box-sizing: border-box;
}
.autoaddress-control .autoaddress-autocomplete {
  border: solid 1px #ccc;
  position: absolute;
  z-index: 1;
  width: 99.8%;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-shadow: 0 6px 12px rgb(0 0 0 / 30%);
}
.express-vue-temp
  .custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::after {
  background-color: orange;
  color: white;
}
.express-vue-temp
  .custom-radio
  .custom-control-input:checked
  ~ .custom-control-label::after {
  background-color: orange;
  color: white;
  border-radius: 50%;
}
.checkbox label,
.radio label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 0px;
  margin: 0;
  line-height: 30px;
  min-height: 30px;
  font-weight: 400;
  cursor: pointer;
}
.express-vue-temp .custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
  padding-left: 0px !important;
}
.checkbox label,
.radio label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 0px !important;
  margin: 0;
  line-height: 30px;
  min-height: 30px;
  font-weight: 400;
  cursor: pointer;
}
.b-calendar-grid {
  margin: 15px 0 !important;
}
.b-calendar-grid-body > .row {
  padding: 0 !important;
  margin: 0;
}
.radio-custom > .checkbox label::before,
.radio label::before {
  content: none !important;
}
.radio-custom > .checkbox label::after,
.radio label::after {
  content: none !important;
}
.dp-nudge {
  height: 45px;
  width: 100%;
  margin-bottom: 15px;
}
.dp-nudge > button {
  float: left;
  width: 10%;
  padding: 0.375rem 0;
  height: 100%;
}
.dp-nudge > label {
  float: left;
  width: 90%;
  border: none;
}

.custom-control-label {
  display: inline !important;
}
</style>
